var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"distribution__wrapper"},[_c('div',{staticClass:"distribution__text"},[_vm._v(_vm._s(_vm.$t('freebet.popup.finished_distribution')))]),_c('div',{staticClass:"distribution__close",on:{"click":_vm.closePopup}},[_c('div',{staticClass:"wrapper_btn_close"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }